module.exports = "<app-info-modal title=\"Your Session Has Expired\" bodyText=\"You will be redirected to the login screen.\" [redirectLink]=\"redirectLink\"></app-info-modal>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/session-timeout-modal/session-timeout-modal.component.html
// module id = ./src/app/shared/components/session-timeout-modal/session-timeout-modal.component.html
// module chunks = main